var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonIconApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.681,
    height: 77.514,
    viewBox: "0 0 78.681 77.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ButtonIcon_apply",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_946",
    "data-name": "Tracciato 946",
    d: "M39.016,0,12.8,6.583,0,33.77,13.373,63.986,43.021,66.7,58.4,60.65l9.738-20.883L65.45,18.521Z",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 0, 11.831)",
    fill: "#826c9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_947",
    "data-name": "Tracciato 947",
    d: "M27.178,0,11.8,22.554,5.4,9.164,0,16.777l13.528,12.7L33.55,7.431Z",
    transform: "translate(22.415 25.54)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconApply);
export default __webpack_public_path__ + "static/media/ButtonIcon_apply.b5ac32e3277eecf7f8b84a65fd9ca638.svg";
export { ForwardRef as ReactComponent };